import { Base64 } from 'js-base64'

export const parseBase64 = (data) => {
  return `data:;base64,${data.data}`
}

export const parseBase64Stream = (data) => {
  return `data:application/octet-stream;base64,${data.data}`
}

export const typeFromData = (data) => {
  let extension = null

  if (data.indexOf('iVBOR') !== -1) {
    extension = 'png'
  }

  if (data.indexOf('9j/') !== -1) {
    extension = 'jpeg'
  }

  return extension
}

export const imageFromData = (data, ext) => {
  return `data:image/${ext};base64,${data}`
}
